import React, { ReactElement } from 'react';
import {
  Col, Link, Row, Text,
} from 'idsk-react-components';
import './legislativnyMaterialDetailRow.scss';
import AktEuDetail from '../../../../../../model/legislativnyMaterial/AktEuDetail';
import externalRoutes from '../../../../../../routing/externalRoutes';

interface Props {
  data: AktEuDetail;
}

const AktEu = ({
  data,
}: Props): ReactElement => {
  const renderLink = (): ReactElement => (
    <>
      <Link
        className="pridat-polozku__button"
        to={externalRoutes.aktEu.detail.withParams(data.uuid)}
        target="_top"
      >{data.aktEuId}
      </Link>
    </>
  );

  return data ? (
    <Row className="material-detail-row">
      <Col width="one-third">
        <Text type="span" className="information-header">Akt EÚ</Text>
      </Col>
      <Col width="two-thirds">
        {renderLink()}
      </Col>
    </Row>
  ) : <></>;
};

export default AktEu;
